import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMonzoComponent } from './simple-icons-monzo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMonzoComponent ],
    exports:      [ SimpleIconsMonzoComponent ],
    bootstrap:    []
})
export class SimpleIconsMonzoModule {}
